import type React from 'react'
import { useState } from 'react'
import { Paper, Button, Box, TextField, Popper, ClickAwayListener } from '@mui/material'
import { WorkUnitCellEditHandler, WorkUnitGridRow } from './WorkUnitTable'

interface UserDataEditPopperProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  open: boolean
  field: string
  validValues?: string[] | undefined
  handleOnEdit: WorkUnitCellEditHandler
  currentValue: unknown
  worklistRowData: WorkUnitGridRow
}

const UserDataEditPopper = (props: UserDataEditPopperProps) => {
  const workUnit = props.worklistRowData
  const [val, setVal] = useState<unknown>(props.currentValue)

  const onSubmit = () => {
    props.handleOnEdit(workUnit, props.field, val)
    props.onClose()
  }

  const handleClose = () => props.onClose()

  const field: React.JSX.Element = (
    <TextField
      variant="standard"
      value={val}
      onChange={e => setVal(e.target.value)}
      placeholder="New value"
    />
  )
  return (
    <Popper
      open={props.open}
      anchorEl={props.anchorEl}
      style={{ zIndex: 100 }}
      placement="bottom-end"
      modifiers={[
        { name: 'preventOverflow', enabled: true },
        { name: 'flip', enabled: false },
      ]}
    >
      <ClickAwayListener onClickAway={handleClose}>
        <Paper style={{ padding: '1rem' }}>
          <Box>{field}</Box>
          <Box
            sx={{
              mt: '16px',
              display: 'flex',
              flex: 1,
              justifyContent: 'flex-end',
              '& button:not(:last-child)': { mr: '1rem' },
            }}
          >
            <Button onClick={e => onSubmit()} variant="contained" color="primary">
              Submit
            </Button>
            <Button onClick={e => handleClose()} variant="contained">
              Cancel
            </Button>
          </Box>
        </Paper>
      </ClickAwayListener>
    </Popper>
  )
}

export default UserDataEditPopper
